export default __webpack_public_path__ + "images/84cf9eb9a7d0c2933fda1d6e4e4f1c31.svg";